import { useState, useEffect } from "react";

import { Row, Col, Breadcrumb, Badge, Dropdown, Button, Modal } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import { useNavigate } from "react-router-dom";

function Header({ subName, onPress }) {
  const navigate = useNavigate();

  const [sidenavType, setSidenavType] = useState("transparent");
  const [breadcrumb, setBreadcrumb] = useState([{ title: "Page" }]);
  useEffect(() => {
    const routes = subName?.split("/")?.map((v) => {
      if (v === "accommodation") return { title: "Houses and Dormitories" };
      if (v === "preschool_grading") return { title: "Nursery Grading" };
      if (v?.includes("_")) {
        const words = v
          .split("_")
          .map((word) => Utilities.capitalizeFirstLetter(word));
        return { title: words.join(" ") };
      }
      return { title: Utilities.capitalizeFirstLetter(v) };
    });

    setBreadcrumb([{ title: "Page" }, ...routes]);
    window.scrollTo(0, 0);
  }, [subName]);

  const dropdownMenuItems = [
    {
      key: "1",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.antgroup.com"
        >
          1st menu item
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.aliyun.com"
        >
          2nd menu item (disabled)
        </a>
      ),
      disabled: true,
    },
    {
      key: "3",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.luohanacademy.com"
        >
          3rd menu item (disabled)
        </a>
      ),
      disabled: true,
    },
    {
      key: "4",
      danger: true,
      label: "a danger item",
    },
  ];

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}>
          <Breadcrumb items={breadcrumb} />
          {/* <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {subName.replace("/", "")}
            </span>
          </div> */}
        </Col>
        <Col span={24} md={18} className="header-control">
          {/* <Badge size="small" count={4}>
            <Dropdown menu={{ items: dropdownMenuItems }} trigger={['click']}>
              <a onClick={e => e.preventDefault()}>
                <i className="fas fa-user-circle fa-2x ms-1" />
              </a>
            </Dropdown>
          </Badge> */}
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {/* toggler */}
            <i className="fas fa-bars fa-2x" />
          </Button>

          <Button
            type="link"
            onClick={() =>
              Modal.confirm({
                title: "Sign Out",
                content: "Are you sure you want to sign out?",
                okText: "Sign Out",
                cancelText: "Cancel",
                onOk: () => Utilities.logout(navigate, "access", "refresh"),
              })
            }
            className="btn-sign-in"
          >
            <i className="fas fa-power-off fa-2x" />
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default Header;
